import { isUndefined } from 'lodash-es';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import useRedirectRoute from '../../../api/login/sideEffects/useRedirectRoute';

const ProtectedRoute = () => {
  const { isLoggedIn } = useAuthContext();
  const { clearRedirect } = useRedirectRoute();
  const { pathname, search, hash } = useLocation();

  if (isUndefined(isLoggedIn)) {
    return null;
  }

  if (isLoggedIn) {
    clearRedirect();
    return <Outlet />;
  }

  const redirectTo = `${pathname}${search}${hash}`;
  const redirectQuery = redirectTo === '/' ? '' : `?${new URLSearchParams({ redirect: redirectTo }).toString()}`;

  return <Navigate to={`/${redirectQuery}`} replace />;
};

export default ProtectedRoute;
